import { AllowedFileTypes } from '../';

export const imageArray: AllowedFileTypes[] = [AllowedFileTypes.JPG, AllowedFileTypes.JPEG, AllowedFileTypes.PNG];
